var exports = {
  "zr": "MacPermissionPrompt.module__root___aEdxZV",
  "Vs": "MacPermissionPrompt.module__tile___aEdxZV",
  "DD": "MacPermissionPrompt.module__title___aEdxZV",
  "X7": "MacPermissionPrompt.module__purpose___aEdxZV",
  "vQ": "MacPermissionPrompt.module__purposeLine___aEdxZV",
  "o1": "MacPermissionPrompt.module__actions___aEdxZV",
  "E3": "MacPermissionPrompt.module__primaryActions___aEdxZV",
  "zB": "MacPermissionPrompt.module__primary___aEdxZV",
  "qD": "MacPermissionPrompt.module__notNow___aEdxZV",
  "TQ": "MacPermissionPrompt.module__allowed___aEdxZV",
  "Wy": "MacPermissionPrompt.module__allowedIn___aEdxZV",
};

module.exports = exports;
